import { Controller } from '@hotwired/stimulus'

// Re-submits a form through its preview button whenever one of its inputs
// changes, including inputs placed outside it with a `form` attribute, so a
// turbo frame beside the form can show what submitting it would do.
export default class extends Controller {
  static targets = ['button']
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.onChange = event => {
      if (event.target.form === this.element) this.refresh()
    }
    document.addEventListener('change', this.onChange)
  }

  disconnect() {
    document.removeEventListener('change', this.onChange)
    clearTimeout(this.timeout)
  }

  refresh() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(this.buttonTarget), this.delayValue)
  }
}
